// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4071":"5d439f45","4705":"31d6cfe0","9094":"96c51a3c"}[chunkId] + ".chunk.css";
};